import React, { Component } from 'react';
import $ from 'jquery'; 

class Week extends Component {
	componentDidUpdate() {	
		if (this.props.data.monday === true)
			$('#mondayItem').addClass("week-day__success");

		if (this.props.data.tuesday)
			$('#tuesdayItem').addClass("week-day__success");

		if (this.props.data.wednesday)
			$('#wednesdayItem').addClass("week-day__success");

		if (this.props.data.thursday)
			$('#thursdayItem').addClass("week-day__success");

		if (this.props.data.friday)
			$('#fridayItem').addClass("week-day__success");

		if (this.props.data.saturday)
			$('#saturdayItem').addClass("week-day__success");

		if (this.props.data.sunday)
			$('#sundayItem').addClass("week-day__success");			

		var d = new Date();		
		switch(d.getDay()) {
			case 0:
				$('#sundayItem').html("_");	
				$('#sundayItem').removeClass("week-day__success");		
				break;
			case 1:
				$('#mondayItem').html("_");	
				$('#mondayItem').removeClass("week-day__success");		
				break;
			case 2:
				$('#tuesdayItem').html("_");	
				$('#tuesdayItem').removeClass("week-day__success");	
				break;
			case 3:
				$('#wednesdayItem').html("_");
				$('#wednesdayItem').removeClass("week-day__success");			
				break;
			case 4:
				$('#thursdayItem').html("_");	
				$('#thursdayItem').removeClass("week-day__success");	
				break;
			case 5:
				$('#fridayItem').html("_");	
				$('#fridayItem').removeClass("week-day__success");	
				break;
			case 6:
				$('#saturdayItem').html("_");
				$('#saturdayItem').removeClass("week-day__success");		
				break;
			default:
				break;	
		}
	}
	render() {
		return (
			<div className="week-frame hidden">
				<ul className="week-ul">
					<li id="mondayItem">M</li>
					<li id="tuesdayItem">T</li>
					<li id="wednesdayItem">W</li>
					<li id="thursdayItem">T</li>
					<li id="fridayItem">F</li>
					<li id="saturdayItem">S</li>
					<li id="sundayItem">S</li>
				</ul>					
			</div>
		);
	}
}

export default Week;


// WEBPACK FOOTER //
// ./src/Components/Week/Week.js